import { BUTTON_HEIGHT } from "@lhd/constants";
import { FC } from "react";
import { Separator } from "./styled";

/** Same formula as workers toolbar: BUTTON_HEIGHT.small + 5 */
export const TOOLBAR_SEPARATOR_HEIGHT = BUTTON_HEIGHT.small + 5;

type Props = {
  /** Prefer BUTTON_HEIGHT[displaySize] + 5 so it matches adjacent buttons. */
  height?: number;
  className?: string;
};

/** Vertical divider between toolbar button groups (workers style). */
const ToolbarSeparator: FC<Props> = ({
  height = TOOLBAR_SEPARATOR_HEIGHT,
  className,
}) => <Separator $height={height} className={className} aria-hidden />;

export default ToolbarSeparator;
